import React, {FC} from "react"
import {Address} from "@irati/types"
import {Col} from "@irati/ui/src/ColumnRow"
import Form from "./Form"
import {MobileCol} from "./Form/styled"

interface Props {
  onFieldChange: (newAddress: Partial<Address>) => void
  onClick: () => void
  load: Promise<any> | undefined
  shippingAddress: Address
}

const DeliveryAddressForm: FC<Props> = (props) => {
  return (
    <>
      {/* Desktop */}
      <Col md={12} lg={6} xsHidden>
        <Form {...props} />
      </Col>

      {/* Mobile */}
      <MobileCol smHidden mdHidden lgHidden>
        <Form {...props} />
      </MobileCol>
    </>
  )
}

export default DeliveryAddressForm
